<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Select } from '@Shelly/shelly-design-system';
	import {
		createMemberSettingsSnapshot,
		createMemberStatusSnapshot,
	} from 'src/stores/device-runtime/status-selectors';
import { devices } from 'src/stores/lists/devices';
	import { getUniqueFirmwareVersions } from '../helpers/firmware_compare_helpers';

	export let appliedFilters;
	export let toggleFilterOptions;

	$: deviceIds = Object.keys($devices);
	$: memberStatusStore = createMemberStatusSnapshot(deviceIds);
	$: memberSettingsStore = createMemberSettingsSnapshot(deviceIds);
	$: memberStatus = $memberStatusStore;
	$: memberSettings = $memberSettingsStore;
	$: firmwareOptions = getUniqueFirmwareVersions($devices, memberSettings, memberStatus);

	let selectedValue: string | { title: string; value: string } = appliedFilters.firmware_version
		? (firmwareOptions.find((o) => o.value === appliedFilters.firmware_version) ??
			appliedFilters.firmware_version)
		: undefined;

	const handleChange = (e: CustomEvent) => {
		const val = e.detail;
		if (typeof val === 'object' && val !== null) {
			appliedFilters.firmware_version = val.value;
		} else {
			appliedFilters.firmware_version = val ?? '';
		}
	};

	const handleClear = () => {
		appliedFilters.firmware_version = '';
		selectedValue = undefined;
	};

	const resetData = () => {
		appliedFilters.firmware_version = '';
		selectedValue = undefined;
	};
</script>

<svelte:window on:reset={resetData} />

<Select
	aria-label={$format('text_firmware_version', {
		default: 'Firmware version',
	})}
	id="firmware-version-filter"
	isAutocomplete
	clearButton
	a11yProps={{ clearButtonAriaLabel: 'Clear firmware version filter' }}
	options={firmwareOptions}
	bind:value={selectedValue}
	icon="fas fa-microchip"
	label={$format('text_firmware_version', {
		default: 'Firmware version',
	})}
	on:change={handleChange}
	on:clear={handleClear}
/>
